<ng-template #cardContent let-attribute="attribute">
  <mat-card [class.CurrentNav]="activeItem() === attribute">
      <mat-card-content>
        <button (click)="menuItemClick(attribute)" mat-flat-button [class.OutlineIncomplete]="isIncomplete(attribute) && shouldHighlightIncompletes()">
          <div class="Flexbox Align--center Justify--space-between ButtonContent">
            <div class="Grid Gap--smallest Align--flex-start KeyValueContainer">
              <div class="Flexbox Align--center">
                @if(attribute === 'Gemstones') {
                  @if(!getAttributeValue('gemstones')) {
                    <span class="BigText" [ngStyle]="getStyle(attribute)">{{ attribute }}</span>
                  } @else {
                    <span class="LittleTitle">{{ attribute }}</span>
                  }
                } @else {
                  <span class="LittleTitle">{{ attribute }}</span>
                  <span *ngIf="isRequired(attribute)" class="mat-critical">*</span>
                }
              </div>
              <span class="BigText" [ngStyle]="getStyle(attribute)">
                @if (attribute === 'Engraving' && !getAttributeValue(attribute)) {
                  No Engraving
                } @else {
                  @if(attribute === 'Gemstones') {
                    {{ getAttributeValue('gemstones') }}
                  } @else {
                    {{ getAttributeValue(attribute) }}
                  }
                }
              </span>
            </div>
            <div class="Flexbox Align--center">
              <mat-icon>chevron_right</mat-icon>
            </div>
          </div>
        </button>
      </mat-card-content>
    </mat-card>
</ng-template>

<div>
  <button mat-icon-button (click)="closeButtonClicked()"><mat-icon>close</mat-icon></button>
</div>
<div class="Grid Gap--smaller ListContainer" [class.AnimateOut]="shouldAnimateOut">
  @for (attribute of attributeKeys(); track $index) {
    @if (attribute === 'Gemstones' && getAttributeValue('gemstones')) {
      <div class="Flexbox GemstoneWrapper Align--center Gap--tiny">
        <ng-container *ngTemplateOutlet="cardContent; context: { attribute: attribute }"></ng-container>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="cardContent; context: { attribute: attribute }"></ng-container>
    }
  }
</div>